'use client';

import { c as _c } from "react/compiler-runtime";
import type { VideoPlayerProps } from '@repo/ui/components/video/video-player/video-player';
import { lazy, Suspense } from 'react';
const VideoPlayerLazy = lazy(() => import('@repo/ui/components/video/video-player/video-player').then(mod => ({
  default: mod.VideoPlayer
})));
export const LazyVideoPlayer = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Suspense fallback={null}><VideoPlayerLazy {...props} /></Suspense>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};